import genericClub from "img/default_team_logo.webp";
import moment from "moment";

function App({
  homeTeamName = "",
  homeTeamLogo = genericClub,
  awayTeamName = "",
  awayTeamLogo = genericClub,
  gameDate = "",
  score,
}) {
  // get the teams in the backend;
  return (
    <div
      className="flex"
      style={{
        borderRadius: "15px",
        padding: "12px",
      }}
    >
      <div>
        <img
          style={{ width: "70px", height: "45px" }}
          alt="clubImage"
          src={homeTeamLogo ? homeTeamLogo : genericClub }
        ></img>
        <p className="bold">{homeTeamName}</p>
      </div>
      <p className="bold" style={{ margin: "auto" }}>
        {"  "}
        {score ? score : moment(gameDate).format('ll')}
        {"  "}
      </p>
      <div>
        <img
          style={{ width: "70px", height: "45px" }}
          alt="clubImage"
          src={awayTeamLogo}
        ></img>
        <p className="bold">{awayTeamName}</p>
      </div>
    </div>
  );
}

export default App;
